class Validator {
    static validateRealname(name) {
        const re = /^[가-힣]{2,20}|[a-zA-Z]{2,20}\s?[a-zA-Z]{2,20}$/;

        return re.test(name);
    }

    static validateEmail(email) {
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        return re.test(email);
    }

    static validateBirthday(birthday) {
        // YYYY-MM-DD
        const re = /^[1-2]{1}[0-9]{3}\-([0]{1}[1-9]{1}|[1]{1}[0-2]{1})-([0-2]{1}[0-9]{1}|[3]{1}[0-1]{1})$/;

        return re.test(birthday);
    }
}

export default Validator;



// WEBPACK FOOTER //
// ./js/waglebagle/validator.js